import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";
import ServiceDetailsThree from "../containers/services/serv3";
import Bloggridthree from "../containers/blog-grid/blog-grid-three";

const ServiceDetails = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>HT-Call | Délégation des RH</title>
        <meta
          name="description"
          content="Service details page of React VOIP, Telecom and Cloud Services Template."
        />
      </MetaTags>
      <LayoutOne>
        {/* breadcrumb */}
        <Breadcrumb title="Délégation des RH" />
        {/* service details */}
        <ServiceDetailsThree />
        <Bloggridthree/>
      </LayoutOne>
    </Fragment>
  );
};

export default ServiceDetails;
